import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import PageInfoListEdit from "../../components/PageInfoListEdit";
import PageInfoListItemEdit from "../../components/PageInfoListItemEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function DetViTrorPaa() {
    const uploadFolderId = '1G1tm9SC4Suim42E46xZaEmYRcMStGt-X';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/DetViTrorPaa">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoEdit sectionKey="Sec1" />
                <PageInfoListEdit sectionKey="Sec2">
                    <PageInfoListItemEdit sectionKey="item1"/>
                    <PageInfoListItemEdit sectionKey="item2"/>
                    <PageInfoListItemEdit sectionKey="item3"/>
                    <PageInfoListItemEdit sectionKey="item4"/>
                    <PageInfoListItemEdit sectionKey="item5"/>
                    <PageInfoListItemEdit sectionKey="item6"/>
                    <PageInfoListItemEdit sectionKey="item7"/>
                    <PageInfoListItemEdit sectionKey="item8"/>
                    <PageInfoListItemEdit sectionKey="item9"/>
                    <PageInfoListItemEdit sectionKey="item10"/>
                </PageInfoListEdit>
                <PageInfoEdit sectionKey="Sec3" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}